export default "__VITE_ASSET__220e2c24__"